__turbopack_context__.v({
  "container": "zT4U6W_container",
  "discountLabel": "zT4U6W_discountLabel",
});
